export const AuctionBidMinStep: number = 5000;
export const AuctionBidMaxStep: number = 299000;
